const DashboardConstantsAR = {
  dashboardUsersPaperTitle: 'المستخدمين',
  dashboardUsersPaperSubTitle: 'كافة المستخدمين النشطين',
  dashboardMediasPaperTitle: 'الفيديوهات',
  dashboardMediasPaperSubTitle: 'مجموع الفيديوهات المنشورة',
  dashboardOrdersPaperTitle: 'الطلبات',
  dashboardOrdersPaperSubTitle: 'إجمالي الطلبات المستلمة',
  viewAllLabel: 'عرض الكل',

  signUpTableLabel: 'أحدث طلبات تسجيل المستخدمين',
  signupRequestCountryColumn: 'الدولة',
  signupRequestCompanyNameColumn: 'إسم الجهة',
  signupRequestPurposeOfUseColumn: 'سبب الإستخدام',
  mediaTableLabel: 'أحدث المواد المنشورة',
  proposalRequestsTableLabel: 'أحدث طلبات العروض',
  ordersTableLabel:'أحدث الطلبات',
};

export default DashboardConstantsAR;
